export default {
  operate: {
    update: '更新',
    sell: '发布',
    search: '搜索',
    refresh: '刷新',
    delete: '删除',
    saveAsDraft: '保存为@:profile.status.draft',
    reset: '重置',
    share: '分享',
    backToTop: '回到顶部',
    nextPage: '下一页',
    prevPage: '上一页',
    switchSchool: '切换学校',
  },
  user: {
    profile: '账户',
    changePassword: '更改密码',
    manage: '管理',
    like: '收藏夹',
    signup: '注册',
    login: '登录',
    logout: '登出',
    personal: '个人主页',
    secure: '求购',
  },
  profile: {
    username: '用户名',
    email: '电子邮箱',
    experience: '经验值',
    password: '密码',
    verifyPassword: '验证密码',
    forgetPassword: '忘记密码？',
    noAccount: '还没有账户？',
    clickToSignup: '点击这里注册',
    phone: '移动电话',
    school_switch: '所属/默认发布学校切换',
    avatar: '头像',
    category: '分类',
    itemName: '标题',
    price: '价格',
    detail: '详细描述',
    contact: '联系方式',
    cover: '封面',
    status: {
      all: '全部',
      selling: '出售中',
      draft: '草稿',
      sold: '已售出',
    },
  },
  notify: {
    noData: '无数据',
    noPhoto: '无照片',
    clickToDelete: '点击图片删除',
    alsoView: '看了该宝贝的人还看了',
  },
};



// WEBPACK FOOTER //
// ./src/lang/zh-CN.js